export default "__VITE_ASSET__752743bc__"